<template>
<a-row>
  <a-row style="overflow: hidden">
    <a-col :span="span" style="cursor: pointer;" v-for="(item, index) in items" :key="index">
      <a-row>
        <a-col v-if="index == (items.length - 1)" @click="showTab($event, index)" :span="24" class="title" style="color: #40a9ff">
          {{item.BID_TYPE}}
        </a-col>
        <a-col v-else="" @click="showTab($event, index)" :span="24" class="title">
          {{item.BID_TYPE}}
        </a-col>
      </a-row>
      <a-row>
        <a-col @click="showTab($event, index)" :span="12" class="line">
        </a-col>
        <a-col @click="showTab($event, index)" :span="12" class="line">
        </a-col>
        <a-col @click="showTab($event, index)" :span="24" style="margin-top: -3.8px">
          <div :class="'dot ' +  item.version"></div>
        </a-col>
      </a-row>
      <a-row>
        <a-col @click="showTab($event, index)" :span="24" :class="'time-base ' + item.version + '_font'">
          {{item.pub_time | TimeChangeUtc}}
        </a-col>
      </a-row>
      <a-row v-if="index == (items.length - 1)" class="active-tab" style="border-bottom: 1px solid #40a9ff">
        <a-col :span="24" class="tooltip-line">
          <div class="tooltip-top"></div>
        </a-col>
      </a-row>
      <a-row v-else="" class="hidden-tab" style="border-bottom: 1px solid #40a9ff">
        <a-col :span="24" class="tooltip-line">
          <div class="tooltip-top"></div>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
  <a-row>
    <a-col :span="24" v-for="(item, index) in items" :key="index">
      <a v-if="index == (items.length - 1)"  class="active-tab" style="padding-top: 8px" :href="item.url" target="_black">原文链接</a>
      <a v-else=""  class="hidden-tab" style="padding-top: 8px" :href="item.url" target="_black">原文链接</a>
      <div v-if="index == (items.length - 1)" style="padding-top: 8px" class="active-tab" v-html="item.CONTENT_CODE"></div>
      <div v-else=""  class="hidden-tab" style="padding-top: 8px" v-html="item.CONTENT_CODE"></div>
    </a-col>
  </a-row>
</a-row>
</template>

<script>
  function getStyle(elem, prop) {
    if (elem.currentStyle) {
      var res= elem.currentStyle.margin;
    } else if (window.getComputedStyle) {
      if (window.getComputedStyle.getPropertyValue) {
        var res= window.getComputedStyle(elem, null).getPropertyValue(prop);
      } else {
        var res =window.getComputedStyle(elem)[prop];
      }
    }
        return res;
  }
  var fontsizeUpperBound = 16;
  var fontsizeLowerBound = 14;

  var maxFontSize = -1.0;
  var minFontSize = 1000000.0;
  function minmaxFontSize(n) {
    if (!n.childNodes)
      return;

    for (var i = 0; i < n.childNodes.length; i++) {
      if (n.childNodes[i].nodeType == Node.ELEMENT_NODE) {
        var fs = getStyle(n.childNodes[i], "fontSize");
        var ifs = parseFloat(fs);

        if (ifs > maxFontSize)
          maxFontSize = ifs;

        if ( ifs < minFontSize)
          minFontSize = ifs;

        minmaxFontSize(n.childNodes[i]);
      }
    }
  }

  var k = 0.0;
  var b = 0.0;

  function setupKB() {
    var minmaxDelta = (maxFontSize - minFontSize);
    var lowerupperDelta = (fontsizeUpperBound - fontsizeLowerBound);
    k = (minmaxDelta < 0.000001 ? 0.0 : lowerupperDelta / minmaxDelta) ;
    b = (minmaxDelta < 0.000001 ?  fontsizeLowerBound : (maxFontSize * fontsizeLowerBound - minFontSize * fontsizeUpperBound) / minmaxDelta ) ;
  }

  function normalizeFontSize(n) {
    if (!n || ! n.childNodes)
      return;

    for (var i =0; i < n.childNodes.length; i++) {
      if (n.childNodes[i].nodeType == Node.ELEMENT_NODE) {
        var fs = getStyle(n.childNodes[i], "fontSize");
        var ifs = parseFloat(fs);
        var newfs = k * ifs + b;
        n.childNodes[i].style.fontSize = newfs + "px";
        normalizeFontSize(n.childNodes[i]);
      }
    }
  }

export default {
  name: 'BiddingTab',
  props: {
    items:  {
      type: Array,
      default: function() {
        return []
      }
    },
    span: {
      type: Number,
      default: function() {
        let step = parseInt(24/ this.items.length)
        if (step < 2) 
          step = 2
        return step
      }
    },
    content_code: {
      type: String,
      default: function() {
        ""
      }
    }
  },
  methods: {
    showTab: function(e, index) {
      let target = e.target;
      let root = target.parentNode.parentNode.parentNode.parentNode;
      let tools = target.parentNode.parentNode.parentNode;
      for (let i = 0; i < tools.childNodes.length; i++) {
        let tool = tools.childNodes[i].lastChild
        let title = tools.childNodes[i].firstChild.firstChild;
        if (i == index) {
          tool.className = "active-tab ant-row"
          title.style.color = "#40a9ff"
        } else {
          tool.className = "hidden-tab ant-row"
          title.style.color = "gray";
        }
      }
      target = root.lastChild
      for(let i = 0; i < target.childNodes.length; i++) {
        let line = target.childNodes[i]
        if (i == index) {
          line.firstChild.className = "active-tab"
          line.lastChild.className = "active-tab"
        } else {
          line.firstChild.className = "hidden-tab"
          line.lastChild.className = "hidden-tab"
        }
      }
    }
  },
  filters: {
    TimeChangeUtc(value) {
      value = parseInt(value);
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let y = date.getFullYear();

      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;

      let d = date.getDate();
      d = d < 10 ? "0" + d : d;

      let h = date.getHours();
      h = h < 10 ? "0" + h : h;

      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;

      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;

      //return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      return y + "-" + MM + "-" + d
    }
  },
  mounted:function(){
    let nodes = this.$el.childNodes[1].childNodes
    for(let i = 0; i < nodes.length; i++) {
      let line = nodes[i]
      minmaxFontSize(line);
      setupKB();
      normalizeFontSize(line);
    }
  },
  created() {
    for(let i = 0; i < this.items.length; i++) {
      if (i == this.items.length - 1) {
        this.items[i]["tooltip"] = true
      } else {
        this.items[i]["tooltip"] = false
      }
    }
  }
}
</script>

<style scoped>
  .title {
    text-align: center; 
    padding: 6px;
  }
  .line {
    height:0px; 
    border-top: 1px solid #BDBDBD;
    //background-color:#BDBDBD;
  }
  .tooltip-line {
    height: 0px; 
    text-align: center; 
    margin-top: -5px;
  }
  .tooltip-top {
    width: 0px; 
    height: 0px;
    border-width: 0px 5px 5px;
    border-color: transparent;
    border-style: solid;
    border-bottom-color: #40a9ff;
    position: absolute; 
    left: 50%;
  }
  .active-tab {
    display: block;
    overflow: hidden;
  }
  .hidden-tab {
    display: none;
    overflow: hidden;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
  }
  .pre {
    background-color: #1890ff;
  }
  .announce, .update, .review {
    background-color: #52c41a;
  }
  .result, .deal {
    background-color: #fadb14;
  }
  .terminate {
    background-color: #f5222d;
  }
  .time-base {
    text-align: center; 
    padding: 6px;
    font-weight: 600;
  }
  .pre_font {
    color: #1890ff;
  }
  .announce_font, .update_font, .review_font {
    color: #52c41a;
  }
  .result_font, .deal_font {
    color: #fadb14;
  }
  .terminate_font {
    color: #f5222d;
  }
</style>
